import { makeNumberSchema, makeStrictNumberSchema } from '../general/number.ts';

const MIN = 1;
const MAX = 65_535; // backend validates lighthouse.interval as a uint16 (configOverrideUint16)

const minMessage = `Interval must be at least ${MIN.toLocaleString()} second`;
const maxMessage = `Interval can be at most ${MAX.toLocaleString()} seconds`;
const requiredMessage = `Choose a number from ${MIN.toLocaleString()} to ${MAX.toLocaleString()}`;

export const lighthouseIntervalSchema = makeNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
});

export const lighthouseIntervalRequiredSchema = lighthouseIntervalSchema.refine((val): val is number => val !== null, {
  message: requiredMessage,
});

export const lighthouseIntervalStrictSchema = makeStrictNumberSchema({
  min: { value: MIN, message: minMessage },
  max: { value: MAX, message: maxMessage },
  required: { message: requiredMessage },
});
